"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applicationStatusSearchQuery = exports.applicationSearchByOrderIdQuery = exports.applicationSearchQuery = exports.getLatestApplicationStatusQuery = exports.getLatestApplicationStatusByOrderIdQuery = exports.findApplicationStatusByCaseNumberQuery = void 0;
const types_1 = require("../../types");
exports.findApplicationStatusByCaseNumberQuery = `
  query findApplicationStatusByCaseNumber($caseNumber: Int!, $financeProvider: Int) {
    findApplicationStatusByCaseNumber(caseNumber: $caseNumber, financeProvider: $financeProvider) {
      ...application
    }
  }
  ${types_1.applicationStatusFragment}
`;
exports.getLatestApplicationStatusByOrderIdQuery = `
  query getLatestApplicationStatusByOrderId($orderId: String!, $financeProvider: Int) {
    getLatestApplicationStatusByOrderId(orderId: $orderId, financeProvider: $financeProvider) {
      ...application
    }
  }
  ${types_1.applicationStatusFragment}
`;
exports.getLatestApplicationStatusQuery = `
  query getLatestApplicationStatus($input: ApplicationSearchInput!, $financeProvider: Int) {
    getLatestApplicationStatus(input: $input, financeProvider: $financeProvider) {
      ...application
    }
  }
  ${types_1.applicationStatusFragment}
`;
exports.applicationSearchQuery = `
  query applicationSearch($input: ApplicationSearchInput!, $financeProvider: Int) {
    applicationSearch(input: $input, financeProvider: $financeProvider) {
      caseNumber
      insertDate
      regNumber
      salesChannelName
      status
    }
  }
`;
exports.applicationSearchByOrderIdQuery = `
  query applicationSearchByOrderId($orderId: String!, $financeProvider: Int) {
    applicationSearchByOrderId(orderId: $orderId, financeProvider: $financeProvider) {
      caseNumber
      insertDate
      regNumber
      salesChannelName
      status
    }
  }
`;
exports.applicationStatusSearchQuery = `
  query applicationStatusSearch($input: ApplicationSearchInput!, $financeProvider: Int) {
    applicationStatusSearch(input: $input, financeProvider: $financeProvider) {
      ...application
    }
  }
  ${types_1.applicationStatusFragment}
`;
//# sourceMappingURL=application.js.map